import React, { useState } from 'react';

import {
  FormControl,
  FormLabel,
  RadioGroup as MuiRadioGroup,
} from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { RadioButton } from '../../../atoms/RadioButton';

const useStyles = makeStyles((theme: Theme) => ({
  radioGroup: {
    '& [class*="MuiFormControlLabel-root"]': {
      margin: 0,
      padding: theme.spacing(1, 0),
    },
  },
}));

export interface RadioGroupProps {
  groupLabel?: string;
  options: JSX.Element[];
}

export const RadioGroup = (props: RadioGroupProps): JSX.Element => {
  const { groupLabel = 'Options', options } = props;

  const [value, setValue] = useState('');
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };

  return (
    <FormControl>
      <FormLabel>{groupLabel}</FormLabel>
      <MuiRadioGroup
        className={classes.radioGroup}
        value={value}
        onChange={handleChange}
      >
        {options.map((option, index) => (
          <RadioButton {...option} {...option.props} key={index} />
        ))}
      </MuiRadioGroup>
    </FormControl>
  );
};
